import React from 'react';
import { WebsiteLayout } from '../components/common/layout';
import { HowItWorks } from '../components/screens';

export default function PageWithLayout({ logout, user }) {
  return (
    <WebsiteLayout navbarBackgroundColor="white" user={user} handleLogout={logout}>
      <HowItWorks />
    </WebsiteLayout>
  );
}
